import { render, staticRenderFns } from "./QuickCreate.vue?vue&type=template&id=2db5712c&scoped=true"
import script from "./QuickCreate.vue?vue&type=script&lang=js"
export * from "./QuickCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickCreate.vue?vue&type=style&index=0&id=2db5712c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5712c",
  null
  
)

export default component.exports